<template>
  <section class="shadow-box">
    <div class="popup-message">
      <div class="header-wrapper">
        <span class="main-title">{{ currentDisplayedSignal.symbol }}</span>
        <div class="close" @click="setShowSignalModal({ showPopup: false })">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
          >
            <g transform="translate(0)">
              <g transform="translate(0 0)">
                <rect
                  width="17.423"
                  height="2.376"
                  transform="translate(0 12.32) rotate(-45)"
                  class="a"
                />
              </g>
              <rect
                width="17.423"
                height="2.376"
                transform="translate(1.68 0) rotate(45)"
                class="a"
              />
            </g>
          </svg>
        </div>
      </div>
      <div class="main-section">
        <img :src="currentDisplayedSignal.chartImage" />
        <div class="content-wrapper">
          <div class="desktop">
            <div class="signal-title">{{ currentDisplayedSignal.title }}</div>
            <div class="signal-summary">
              {{ currentDisplayedSignal.summary }}
            </div>
          </div>
          <div class="title">{{ t("Signal_our_preference") }}:</div>
          <div class="content">{{ currentDisplayedSignal.ourPreference }}</div>
          <div class="title">{{ t("Signal_alternative_scenario") }}:</div>
          <div class="content">
            {{ currentDisplayedSignal.alternativeScenario }}
          </div>
          <div class="title">{{ t("Signal_comment") }}:</div>
          <div class="content">{{ currentDisplayedSignal.comment }}</div>
          <div class="title">{{ t("Signal_key_levels") }}:</div>
          <div class="table-wrapper">
            <div class="table-col">
              <div class="cell">
                <div class="title">
                  {{ t("Signal_pivot") }}
                </div>
                <div class="content">
                  {{ currentDisplayedSignal.pivot }}
                </div>
              </div>
              <div class="cell">
                <div class="title">
                  {{ t("Signal_resistance") }}
                </div>
                <div class="content">
                  {{ currentDisplayedSignal.resistance1 }}<br />
                  {{ currentDisplayedSignal.resistance2 }}<br />
                  {{ currentDisplayedSignal.resistance3 }}
                </div>
              </div>
            </div>
            <div class="table-col">
              <div class="cell">
                <div class="title">
                  {{ t("Signal_last") }}
                </div>
                <div class="content">
                  {{ currentDisplayedSignal.last }}
                </div>
              </div>
              <div class="cell">
                <div class="title">
                  {{ t("Signal_support") }}
                </div>
                <div class="content">
                  {{ currentDisplayedSignal.support1 }}<br />
                  {{ currentDisplayedSignal.support2 }}<br />
                  {{ currentDisplayedSignal.support3 }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapMutations, mapGetters, mapState } from "vuex";

export default {
  name: "SignalModal",
  computed: {
    // ...mapState(['userFirstName','accountId']),
    // ...mapGetters(['userLoginLink'])
    ...mapState("signals", ["currentDisplayedSignal"]),
    ...mapGetters(["t"])
  },
  methods: {
    // ...mapMutations('loginOrRegister', [
    //   'setShowMessageModal',
    // ]),
    ...mapMutations("signals", ["setShowSignalModal"])
  },
  mounted() {
    let documentHeight = document.body.offsetHeight + "px";
    document.getElementsByClassName(
      "shadow-box"
    )[0].style.height = documentHeight;
  }
};
</script>

<style lang="scss" scoped>
h3 {
  font-size: 24px;
}

.shadow-box {
  position: absolute;
  //position: fixed;
  width: 100vw;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.75);
  height: 100%;
  width: 100%;
  z-index: 10000000000000000;
}

.popup-message {
  //position: fixed;
  position: absolute;
  max-width: 1280px;
  width: 90%;
  transform: translate(-50%, 10%);
  height: auto;
  z-index: 9;
  text-align: center;
  background-color: #fff;
  color: #424242;
  left: 50%;
  //top: 50%;
  //transform: translate(-50%, -50%);
}

.header-wrapper {
  display: flex;
  justify-content: space-between;
  padding: 0 20px 0 18px;
  height: 60px;
  align-items: center;
  background-color: #707070;
  color: #ffffff;
  font-size: 1.5rem;

  .a {
    fill: #ffffff;
  }
}

.header-wrapper {
  font-size: 1.125rem;
}

.close {
  margin-right: 4px;
  text-shadow: none;
  opacity: 1;
}

.close:hover {
  cursor: pointer;
}

.main-section {
  line-height: normal;

  img {
    width: 100%;
  }

  .content-wrapper {
    padding: 0.875rem 1rem 1.5rem 1rem;
    text-align: left;

    .title {
      color: #9e9e9e;
      font-size: 1rem;
      margin-bottom: 0.5rem;
    }

    .content {
      color: #424242;
      font-size: 1rem;
      margin-bottom: 0.75rem;
    }

    .table-wrapper {
      display: flex;
      flex-direction: row;
      padding-right: 0.625rem;

      .table-col {
        display: flex;
        flex-direction: column;
        width: 50%;
        border: 1px solid #707070;

        &:first-of-type {
          border-right: none;
        }

        .cell {
          display: flex;
          flex-direction: column;
          //width: 50%;
          .title {
            font-size: 0.875rem;
          }
          .content {
            font-size: 0.875rem;
          }
          :first-child {
            background-color: #e5e5e5;
            color: #424242;
            height: 1.875rem;
            display: flex;
            align-items: center;
          }

          > div {
            padding-left: 0.625rem;
          }
        }
      }
    }
  }
}

@media only screen and (min-width: 890px) {
  .desktop {
    display: block;
  }
  .main-section {
    display: flex;
    flex-direction: row-reverse;
    padding: 38px 50px 45px 56px;

    img {
      max-width: calc(100% - 8.3% - 321px);
    }

    .content-wrapper {
      width: 321px;
      padding: 0;
      margin-right: 8.3%;

      .signal-title {
        font-weight: bold;
        font-size: 1.125rem;
        margin-bottom: 0.5rem;
      }

      .signal-summary {
        font-size: 1rem;
        margin-bottom: 1.5rem;
      }
    }
  }
  @media only screen and (max-width: 1000px) {
    .main-section {
      padding: 19px 25px 22px 28px;

      img {
        max-width: calc(100% - 4% - 321px);
      }

      .content-wrapper {
        margin-right: 4%;
      }
    }
  }
}

@media only screen and (max-width: 890px) {
  .header-wrapper {
    font-size: 1rem;
    height: 40px;
  }
  .desktop {
    display: none;
  }
  .popup-message {
    margin: 0;
    padding: 0;
    max-width: calc(100% - 2rem);
  }
}
</style>
